import type { IOkrs } from '~/types/okr'

import config from '~/config'
import { request } from '~/utils/request'

export const getOkrsData = (): Promise<IOkrs> => {
  return request<IOkrs>({
    url: `${config.VERSIONS_API}/home/okrs`,
  })
}
